import React, {ReactNode} from "react";
import {FormattedMessage} from "react-intl";
import {twJoin} from "tailwind-merge";
import {formatMoney} from "@/utils/MoneyUtils";

type Props = {
    label: ReactNode,
    amount: number,
    orderCount: number,
    share: number | null,
    colorClassName: string,
};

/**
 * Revenue of one payment method: amount, number of orders and share.
 */
const PaymentMethodTotal = ({label, amount, orderCount, share, colorClassName}: Props) => (
    <div className={"grid grid-cols-[12px_minmax(0,1fr)] gap-3"}>
        <span
            aria-hidden={"true"}
            className={twJoin("mt-1 size-3 rounded-sm", colorClassName)}
        />

        <div className={"flex flex-col gap-1"}>
            <p className={"text-sm font-medium text-gray-900 dark:text-white"}>
                {label}
            </p>

            <p className={"font-medium tracking-tight text-gray-900 dark:text-white text-xl"}>
                {formatMoney(amount)}
            </p>

            <p className={"text-sm text-gray-500 dark:text-slate-400"}>
                <FormattedMessage id={"dayReport.nOrders"} values={{n: orderCount}}/>
                {share !== null && ` · ${share}%`}
            </p>
        </div>
    </div>
);

export default PaymentMethodTotal;